export interface AppDetailsSnapshot {
    appName: string
    environment: string
    gitSha: string
    zoomSdkVersion: string
    classroomId: string
    wseUserId: string
    role: string
    zoomTopic?: string
    zoomUserId?: string
    zoomUserName?: string
}

export interface AppDetailsEnv {
    REACT_APP_FARO_PROJECT?: string
    REACT_APP_ENV?: string
    REACT_APP_GIT_SHA?: string
}

export interface ZoomSessionInfo {
    topic?: string
    userId?: number
    userName?: string
}

export interface AppDetailsInput {
    env?: AppDetailsEnv
    sessionStorage?: Pick<Storage, 'getItem'>
    sessionInfo?: ZoomSessionInfo
}

const ZOOM_SDK_VERSION = '2.3.15'

export const collectAppDetails = (input: AppDetailsInput = {}): AppDetailsSnapshot => {
    const env = input.env ?? {
        REACT_APP_FARO_PROJECT: process.env.REACT_APP_FARO_PROJECT,
        REACT_APP_ENV: process.env.REACT_APP_ENV,
        REACT_APP_GIT_SHA: process.env.REACT_APP_GIT_SHA
    }
    const storage = input.sessionStorage ?? (typeof sessionStorage !== 'undefined' ? sessionStorage : { getItem: () => null })

    const snapshot: AppDetailsSnapshot = {
        appName: env.REACT_APP_FARO_PROJECT ?? 'unknown-app',
        environment: env.REACT_APP_ENV ?? 'unknown',
        gitSha: env.REACT_APP_GIT_SHA ?? 'unknown',
        zoomSdkVersion: ZOOM_SDK_VERSION,
        classroomId: storage.getItem('classroomId') ?? '',
        wseUserId: storage.getItem('userId') ?? '',
        role: storage.getItem('role') ?? ''
    }

    if (input.sessionInfo?.topic) {
        snapshot.zoomTopic = input.sessionInfo.topic
    }

    if (input.sessionInfo?.userId !== undefined) {
        snapshot.zoomUserId = String(input.sessionInfo.userId)
    }

    if (input.sessionInfo?.userName) {
        snapshot.zoomUserName = input.sessionInfo.userName
    }

    return snapshot
}
